import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import { Type } from '../../../../types/Controlling/Offer'
import Chart from './Chart'
import { OfferEntry } from '../../../../types/Controlling/OfferEntry'

type Props = {
  entries: OfferEntry[]
}

const QuarterCharts: React.FC<Props> = ({ entries }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getQuarterData = (quarter: number) => {
    return [
      entries.reduce(
        (acc, entry) => {
          const startQuarterDate = new Date(new Date(entry.scheduledDate).getFullYear(), quarter * 3, 1)
          const endQuarterDate = new Date(new Date(entry.scheduledDate).getFullYear(), (quarter + 1) * 3, 0)
          endQuarterDate.setHours(23, 59, 59, 999)
          const entryDate = new Date(entry.scheduledDate)
          if (entryDate >= startQuarterDate && entryDate <= endQuarterDate) {
            return {
              income: acc.income + (entry.offer.type === Type.INCOME ? entry.amount : 0),
              expense: acc.expense + (entry.offer.type === Type.EXPENSE ? entry.amount : 0),
            }
          }
          return acc
        },
        { income: 0, expense: 0 },
      ),
    ]
  }

  return (
    <div className="flex gap-5">
      <Chart data={getQuarterData(0)} title={t.controlling.forecast.quarter[0]} />
      <Chart data={getQuarterData(1)} title={t.controlling.forecast.quarter[1]} />
      <Chart data={getQuarterData(2)} title={t.controlling.forecast.quarter[2]} />
      <Chart data={getQuarterData(3)} title={t.controlling.forecast.quarter[3]} />
    </div>
  )
}

export default QuarterCharts
